import { initializeApp, FirebaseApp } from 'firebase/app';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getStorage, FirebaseStorage } from 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyB1q3An1TNlF126VOSPvL9fypgc6EAM9mw",
    authDomain: "cheapest-car-recovery.firebaseapp.com",
    projectId: "cheapest-car-recovery",
    storageBucket: "cheapest-car-recovery.firebasestorage.app",
    messagingSenderId: "903917436254",
    appId: "1:903917436254:web:cc3866e555aec8a3ffe3cf",
    measurementId: "G-ZET2T72S72"
  };

// Initialize Firebase
let app: FirebaseApp | undefined;
let db: Firestore | undefined;
let storage: FirebaseStorage | undefined;

try {
  app = initializeApp(firebaseConfig);
  db = getFirestore(app);
  storage = getStorage(app);
} catch (error) {
  console.error("Error initializing Firebase:", error);
}

export { db, storage };
export default app; 